import React, { useEffect, useState } from "react";
import {
  formatAicopyDdHhMmCountdown,
  formatAicopyFollowStartTime,
  parseAicopyTimestampMs,
} from "../../utils/couponPositionFields";
import styles from "./index.module.less";

/**
 * 当前跟单：跟随开始时间、跟随时间（xD:HH:MM）、券类型到期倒计时
 */
export default function AicopyOrderFollowMetaRows({ startTime, expireMs, t, detailClassName }) {
  // 首屏与 SSR 保持一致，避免 Date.now() 导致 Hydration mismatch（线上可能因此丢失点击事件）
  const [nowMs, setNowMs] = useState(null);

  useEffect(() => {
    setNowMs(Date.now());
    const timer = setInterval(() => setNowMs(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  const startMs = parseAicopyTimestampMs(startTime);
  const followDurationText =
    nowMs != null && startMs != null
      ? formatAicopyDdHhMmCountdown(Math.max(0, nowMs - startMs))
      : "—";

  const expire = Number(expireMs);
  const showExpire = Number.isFinite(expire) && expire > 0;
  const expireRemainingMs = showExpire && nowMs != null ? Math.max(0, expire - nowMs) : 0;
  const expireCountdownText =
    showExpire && nowMs != null ? formatAicopyDdHhMmCountdown(expireRemainingMs) : "—";

  const rootClass = detailClassName ? `${styles.root} ${detailClassName}` : styles.root;

  return (
    <div className={rootClass}>
      <div className={styles.row}>
        <span className={styles.label}>{t("aicopy.followStartTime")}</span>
        <span className={styles.value}>{formatAicopyFollowStartTime(startTime) || "—"}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>{t("aicopy.followDays")}</span>
        <span className={styles.value}>{followDurationText}</span>
      </div>
      {showExpire ? (
        <div className={styles.row}>
          <span className={styles.label}>{t("aicopy.expireTime")}</span>
          <span className={styles.valueExpire}>{expireCountdownText}</span>
        </div>
      ) : null}
    </div>
  );
}
